import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import {
  type EstateAvailability,
  getEstateAvailabilityLabel,
} from '../constants/estate-availability';

const availabilityStyles: Record<NonNullable<EstateAvailability> | 'unspecified', string> = {
  available: 'bg-emerald-100 text-emerald-800',
  reserved: 'bg-amber-100 text-amber-800',
  sold: 'bg-rose-100 text-rose-800',
  rented: 'bg-sky-100 text-sky-800',
  unspecified: 'bg-slate-100 text-slate-600',
};

type EstateAvailabilityBadgeProps = {
  availability: EstateAvailability;
  className?: string;
};

export const EstateAvailabilityBadge = ({
  availability,
  className,
}: EstateAvailabilityBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex w-fit rounded-full px-3 py-0.5 text-xs font-medium',
        availabilityStyles[availability ?? 'unspecified'],
        className
      )}
    >
      {getEstateAvailabilityLabel(t, availability)}
    </span>
  );
};
